/* eslint-disable no-plusplus */
import moment from "moment";

export const LIST_DAY_IN_WEEK = [
  {
    id: 1,
    name: "Thứ 2"
  },
  {
    id: 2,
    name: "Thứ 3"
  },
  {
    id: 3,
    name: "Thứ 4"
  },
  {
    id: 4,
    name: "Thứ 5"
  },
  {
    id: 5,
    name: "Thứ 6"
  },
  {
    id: 6,
    name: "Thứ 7"
  },
  {
    id: 0,
    name: "Chủ nhật"
  }
];

export const STATIC_DATE_FORMAT = "YYYYMMDD";

export const handleDefaultDate = (type: string) => {
  const now = new Date();
  let filter = {
    first_date: "",
    last_date: ""
  };
  if (type === "month") {
    const firstDate = `${moment(now).format("YYYYMM")}01`;
    filter = {
      first_date: firstDate,
      last_date: moment(firstDate, STATIC_DATE_FORMAT).add(1, "months").subtract(1, "days").format(STATIC_DATE_FORMAT)
    };
  } else if (type === "year") {
    const firstDate = `${moment(now).format("YYYY")}0101`;
    filter = {
      first_date: firstDate,
      last_date: moment(firstDate, STATIC_DATE_FORMAT).add(1, "years").subtract(1, "days").format(STATIC_DATE_FORMAT)
    };
  } else {
    if (moment(now).day() === 1) {
      const firstDate = moment(now).format(STATIC_DATE_FORMAT);
      filter = {
        first_date: firstDate,
        last_date: moment(firstDate, STATIC_DATE_FORMAT).add(6, "days").format(STATIC_DATE_FORMAT)
      };
    }
    if (moment(now).day() === 0) {
      const lastDate = moment(now).format(STATIC_DATE_FORMAT);
      filter = {
        first_date: moment(lastDate, STATIC_DATE_FORMAT).subtract(6, "days").format(STATIC_DATE_FORMAT),
        last_date: lastDate
      };
    } else {
      const totalNum = moment(now).day();
      filter = {
        first_date: moment(now)
          .subtract(totalNum - 1, "days")
          .format(STATIC_DATE_FORMAT),
        last_date: moment(now)
          .add(7 - totalNum, "days")
          .format(STATIC_DATE_FORMAT)
      };
    }
  }
  return filter;
};

export const handleTimeLine = (timeline, firstDate, lastDate) => {
  return timeline?.filter(
    (v) =>
      moment(v.date, STATIC_DATE_FORMAT).isSameOrAfter(firstDate) &&
      moment(v.date, STATIC_DATE_FORMAT).isSameOrBefore(lastDate)
  );
};

export const listDateBetween = (firstDate, secondDate) => {
  const listDays = [firstDate.format(STATIC_DATE_FORMAT)];
  const lengthMax = secondDate.diff(firstDate, "days");
  for (let i = 0; i < lengthMax; i += 1) {
    listDays.push(firstDate.add(1, "days").format(STATIC_DATE_FORMAT));
  }
  return listDays;
};

export const LIST_LABEL_WEEK = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];
export const LIST_LABEL_YEAR = ["Th1", "Th2", "Th3", "Th4", "Th5", "Th6", "Th7", "Th8", "Th9", "Th10", "Th11", "Th12"];

export const fakeDataWeek = [20, null, null, 30, 50, null, 80];

export const convertSpentTimeToTime = (spentTime) => {
  const result = new Date(spentTime * 1000).toISOString().slice(11, 19);
  return result;
};

export const mathYearFromYearToYear = (start: string) => {
  const startYear = Number(moment(start).format("YYYY"));
  const now = Number(moment().format("YYYY"));
  let arrYear: number[] = [];
  for (let i = startYear; i <= now; i++) {
    if (startYear === now) {
      arrYear = [startYear];
      break;
    }
    arrYear = [...arrYear, i];
  }

  return arrYear;
};

export const convertNumberDivisibleFive = (num: number) => {
  const numberDivisibleFive = num % 5 === 0 ? num : num - (num % 5);
  return numberDivisibleFive;
};

export const handleDataTimeLine = (data, selectOption) => {
  const sortData = data?.sort((a: any, b: any) => {
    if (moment(a.date, STATIC_DATE_FORMAT).isBefore(moment(b.date, STATIC_DATE_FORMAT))) {
      return -1;
    }
    if (moment(a.date, STATIC_DATE_FORMAT).isAfter(moment(b.date, STATIC_DATE_FORMAT))) {
      return 1;
    }
    return 0;
  });
  if (selectOption === "week" || selectOption === "month") {
    return sortData;
  }
  let dataYear: any[] = [];
  data.forEach((v: any) => {
    if (dataYear.some((v2: any) => v2.month === moment(v.date, STATIC_DATE_FORMAT).format("MM/YYYY"))) {
      dataYear = dataYear.map((v2) => {
        if (v2.month === moment(v.date, STATIC_DATE_FORMAT).format("MM/YYYY")) {
          return {
            ...v2,
            correct_quiz: v2.correct_quiz + v.correct_quiz,
            finished_quiz: v2.finished_quiz + v.finished_quiz,
            spent_time: v2.spent_time + v.spent_time
          };
        }
        return v2;
      });
    } else {
      dataYear.push({
        month: moment(v.date, STATIC_DATE_FORMAT).format("MM/YYYY"),
        spent_time: v.spent_time,
        correct_quiz: v.correct_quiz,
        finished_quiz: v.finished_quiz
      });
    }
  });
  return dataYear;
};
